var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 13.8289C17.9984 13.8289 19.6188 12.2085 19.6188 10.2097C19.6188 8.21083 17.9984 6.59045 15.9996 6.59045C14.0007 6.59045 12.3804 8.21083 12.3804 10.2097C12.3804 12.2085 14.0007 13.8289 15.9996 13.8289Z",
    fill: "#3A57FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1332 16.7232C28.1317 16.7232 29.7518 15.1031 29.7518 13.1046C29.7518 11.1062 28.1317 9.48608 26.1332 9.48608C24.1347 9.48608 22.5146 11.1062 22.5146 13.1046C22.5146 15.1031 24.1347 16.7232 26.1332 16.7232Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86627 16.7239C7.8651 16.7239 9.48547 15.1035 9.48547 13.1047C9.48547 11.1058 7.8651 9.48547 5.86627 9.48547C3.86744 9.48547 2.24707 11.1058 2.24707 13.1047C2.24707 15.1035 3.86744 16.7239 5.86627 16.7239Z",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7901 25.4096H10.2092C10.0174 25.4096 9.83278 25.3336 9.69743 25.1975C9.56135 25.0622 9.48535 24.8776 9.48535 24.6858V20.3429C9.48535 17.5447 11.7538 15.2762 14.552 15.2762H17.4473C20.2455 15.2762 22.5139 17.5447 22.5139 20.3429V24.6858C22.5139 24.8776 22.4379 25.0622 22.3018 25.1975C22.1665 25.3336 21.9819 25.4096 21.7901 25.4096Z",
    fill: "#3A57FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3571 18.3242C8.02631 18.2251 7.67672 18.1715 7.31409 18.1715C6.36735 18.1715 5.36559 18.1715 4.41885 18.1715C2.42041 18.1715 0.799805 19.7921 0.799805 21.7906V24.6858C0.799805 25.0853 1.12407 25.4096 1.52361 25.4096H8.16239C8.08061 25.1794 8.0379 24.9348 8.0379 24.6858V20.3429C8.0379 19.6379 8.15009 18.9597 8.3571 18.3242Z",
    fill: "#494949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8373 25.4096H30.4761C30.8756 25.4096 31.1999 25.0853 31.1999 24.6858V21.7906C31.1999 19.7921 29.5793 18.1715 27.5808 18.1715C26.6341 18.1715 25.6323 18.1715 24.6856 18.1715C24.3229 18.1715 23.9734 18.2251 23.6426 18.3242C23.8496 18.9597 23.9618 19.6379 23.9618 20.3429V24.6858C23.9618 24.9348 23.9191 25.1794 23.8373 25.4096Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam11);
export default __webpack_public_path__ + "static/media/team 1 (1).e855f4f0b2311217b40c5ccfe2edbf5b.svg";
export { ForwardRef as ReactComponent };